import { mergeAttributes, Node } from "@tiptap/core";

const VideoHosted = Node.create({
  name: "videohosted",

  group: "block",
  content: "inline*",

  defining: true,

  addOptions() {
    return {
      HTMLAttributes: {
        controls: true,
        width: 640,
        height: "auto"
      }
    };
  },

  addAttributes() {
    return {
      src: {
        default: null
      }
    };
  },

  addCommands() {
    return {
      setVideoHosted: attributes => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes
        });
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-hosted-video] video"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      {
        "data-hosted-video": ""
      },
      ["video", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
    ];
  }
});

export default VideoHosted;
